<template>
    <iframe v-if="url" :src="url" frameborder="0" scrolling="no"></iframe>
</template>

<script>
export default {
    props: ['token'],
    data() {
        return {
            url: null
        }
    },
    mounted () {
        this.url = window.atob(this.$props.token)

        window.addEventListener('message', (event) => {
            if (event.data.CloseGame) {
                return this.$router.push({name: 'Home'}) 
            }
        })
    }
}
</script>

<style lang="css" scoped>
    iframe {
        display: block; 
        background: #ffffff;
        border: none; 
        height: 100vh;
        width: 100vw;
    }
</style>